module.exports = __webpack_public_path__ + "img/startup-costs.cf30c2b6.svg";